export enum ResourceType {
    Api = 'api',
    Function = 'function',
}